import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import StoryletService from 'services/StoryletService';
import { IQualityRequirement } from "types/storylet";
import { fetchMyself, fetchOutfit } from "actions/myself";
import { IChooseBranchRequestData } from 'types/storylet/service';

type ChooseBranchRequestDataWithQReqs = IChooseBranchRequestData & {
  qualityRequirements?: IQualityRequirement[],
};

export default function chooseGateEventBranch(requestData: ChooseBranchRequestDataWithQReqs) {
  return async (dispatch: Function) => {
    try {
      const service = new StoryletService();
      // Check whether the branch being has cost-type requirements. We will not
      // receive cost-related quality updates in the API response, so we need to
      // prepare to trigger fetches of the character's myself+outfit qualities
      const { qualityRequirements = [] } = requestData;
      const hasCosts = qualityRequirements.some((qreq: IQualityRequirement) => qreq.isCost);

      // Make the request
      const { data } = await service.chooseBranch(requestData);

      // If this branch incurred a cost, then fetch outfit + possessions too
      if (hasCosts) {
        dispatch(fetchMyself());
        dispatch(fetchOutfit());
      }
      return data;
    } catch (e) {
      if (e instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(e));
        return;
      }
      throw e;
    }
  };
}